import { lazy } from "react";
import Footer from "./components/Footer";
import Salons from "./components/Salons";
import WorkWithUs from "./components/WorkWithUs";
import styled from "styled-components";
import Feedbacks from "./components/Feedbacks";
import Logo from "./components/Logo";
import Navbar from "./components/Navbar";
import Location from "./components/Location";
import Banner from "./components/Banner";
import { register } from "swiper/element/bundle";

const MainContainer = styled.div`
  height: 100%;
`;
const BarberCarousel = lazy(() => import("./components/BarberCarousel"));
const PortfolioGallery = lazy(() => import("./components/PortfolioGallery"));

function App() {
  register();
  return (
    <MainContainer>
      <Navbar />
      <Banner />
      <Location />
      <Salons />
      <Logo />
      <BarberCarousel />
      <WorkWithUs />
      <PortfolioGallery />
      <Feedbacks />
      <Footer />
    </MainContainer>
  );
}

export default App;
